<div class="persona-picker" *ngIf="ready">
  <div class="self-profile" *ngIf="selfProfile">
    <se-po-persona-choice
      [profile]="selfProfile"
      (chosen)="onPick($event)"
      (edit)="onEdit($event)"
    ></se-po-persona-choice>
  </div>

  <div class="child-profiles" *ngIf="managedProfiles && managedProfiles.length">
    <h4>{{ 'SE_PO_UI_PERSONA_PICKER.CHILD_PROFILES' | translate }}</h4>

    <se-po-persona-choice
      *ngFor="let profile of managedProfiles"
      [profile]="profile"
      (chosen)="onPick($event)"
      (edit)="onEdit($event)"
    ></se-po-persona-choice>
  </div>
</div>
